import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { EvseState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseStatusSimple',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case EvseState.ES_OFFLINE:
      return tl('stateOffline')
    case EvseState.ES_ONLINE:
      return tl('stateOnline')
    case EvseState.ES_EXCEPTION:
      return tl('stateException')
  }
  return tl('stateNonactivated')
})

const color = computed(() => {
  switch (props.state) {
    case EvseState.ES_OFFLINE:
      return '#5A5F6F'
    case EvseState.ES_ONLINE:
      return '#5e4eff'
    case EvseState.ES_EXCEPTION:
      return '#ff4e4e'
  }
  return '#5A5F6F'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})